import React from 'react';
import { motion } from 'framer-motion';
export const AnnouncementBar: React.FC = () => {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-primary text-white py-2 px-4 text-center text-sm md:text-base font-medium shadow-md" data-id="element-15">
      <motion.div animate={{
      opacity: [1, 0.8, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-16">
        🔥 OFERTA DE LANZAMIENTO — 50% OFF — ¡Solo por tiempo limitado!
      </motion.div>
    </div>;
};